import React from 'react'
import { NumericFormat } from "react-number-format";
import PropTypes from 'prop-types'

const PercentageOffInput = props => {
  const { inputRef, onChange, ...other } = props
  return (
    <NumericFormat
      {...other}
      getInputRef={inputRef}
      allowNegative={false}
      suffix={'%'}
      decimalScale={2}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value
          }
        })
      }}
    />
  )
}

PercentageOffInput.propTypes = {
  props: PropTypes.object
}

export default PercentageOffInput
